var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleWhite = function SvgPeopleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 55 55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.223 34.987a7.537 7.537 0 1 0 0-15.075 7.537 7.537 0 0 0 0 15.075M25.221 49.5c5.17 0 9.36-2.65 9.36-5.918s-4.19-5.918-9.36-5.918-9.36 2.65-9.36 5.918 4.19 5.917 9.36 5.917"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.148 17.19a6.345 6.345 0 1 0 0-12.69 6.345 6.345 0 0 0 0 12.69M13.23 17.19a6.345 6.345 0 1 0 0-12.69 6.345 6.345 0 0 0 0 12.69M36.788 22.117c-.72 0-1.418 0-2.115.113a10.53 10.53 0 0 1-.923 11.857c1.008.2 2.032.305 3.06.315 5.715 0 10.328-2.767 10.328-6.142s-4.635-6.143-10.35-6.143",
    opacity: 0.3
  })));
};
export default SvgPeopleWhite;